/* RESPONSIBLE TEAM: team-ai-insights */

export enum QaStatusValue {
  Unreviewed = 'unreviewed',
  NeedsFix = 'needs_fix',
  WontFix = 'wont_fix',
  FixComplete = 'fix_complete',
  PassedReview = 'passed_review',
}

export type StatusIconType = 'dot-neutral' | 'check-disabled' | 'check-success' | 'alert-notice';

export const STATUS_ICON_TYPES: Record<QaStatusValue, StatusIconType> = {
  [QaStatusValue.Unreviewed]: 'dot-neutral',
  [QaStatusValue.NeedsFix]: 'alert-notice',
  [QaStatusValue.WontFix]: 'check-disabled',
  [QaStatusValue.FixComplete]: 'check-success',
  [QaStatusValue.PassedReview]: 'check-success',
};

export const PINNED_QA_STATUSES = [QaStatusValue.Unreviewed, QaStatusValue.PassedReview];
